/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chapter_TextInputs */

const en_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapter Text`)
};

const es_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto del Capítulo`)
};

const fr_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte du Chapitre`)
};

const de_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapiteltext`)
};

const ja_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`章のテキスト`)
};

const zh_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`章节正文`)
};

const ar_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نص الفصل`)
};

const id_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teks Bab`)
};

const it_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo del Capitolo`)
};

const ru_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст Главы`)
};

const pt_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto do Capítulo`)
};

const ko_chapter_text = /** @type {(inputs: Chapter_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챕터 텍스트`)
};

/**
* | output |
* | --- |
* | "Chapter Text" |
*
* @param {Chapter_TextInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const chapter_text = /** @type {((inputs?: Chapter_TextInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chapter_TextInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chapter_text(inputs)
	if (locale === "es") return es_chapter_text(inputs)
	if (locale === "fr") return fr_chapter_text(inputs)
	if (locale === "de") return de_chapter_text(inputs)
	if (locale === "ja") return ja_chapter_text(inputs)
	if (locale === "zh") return zh_chapter_text(inputs)
	if (locale === "ar") return ar_chapter_text(inputs)
	if (locale === "id") return id_chapter_text(inputs)
	if (locale === "it") return it_chapter_text(inputs)
	if (locale === "ru") return ru_chapter_text(inputs)
	if (locale === "pt") return pt_chapter_text(inputs)
	return ko_chapter_text(inputs)
});